import Component from '../abstracts/Component';
import 'scroll-behavior-polyfill';
import VideoBrightcoveComponent from './VideoBrightcoveComponent';

export default class JournalSliderComponent extends Component {
  get SELECTORS() {
    return {
      journalHp: '.p-journal-hp',
      slide: '[data-slide]',
      scrollCta: '[data-cta-scroll]',
      topCta: '[data-cta-top]',
      journalHero: '[data-journal-hero]',
      header: 'header',
      footer: '.c-footer',
      video: '[data-video]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.page = document.querySelector(this.SELECTORS.journalHp);
    this.height = 0;
    this.slides = this.$component.querySelectorAll(this.SELECTORS.slide);
    this.scrollCtas = this.$component.querySelectorAll(this.SELECTORS.scrollCta);
    this.scrollCtas[this.scrollCtas.length-1].removeAttribute('data-cta-scroll');
    this.scrollCtas[this.scrollCtas.length-1].setAttribute('data-cta-top', '');
    this.topCta = this.$component.querySelector(this.SELECTORS.topCta);
    this.topCta.innerHTML = "Back To Top";
    $(this.topCta).addClass("w-j-s__slide__scroll-cta-top");
    this.journalHero = document.querySelector(this.SELECTORS.journalHero);
    this.heroHeight = this.journalHero.offsetHeight;
    this.header = document.querySelector(this.SELECTORS.header);
    this.headerHeight = this.header.offsetHeight;
    this.footer = document.querySelector(this.SELECTORS.footer);
    this.footerHeight = this.footer ? this.footer.offsetHeight : 0;
    this.currentIndex = -1;
    this.currentSlide = null;
    this.delta = this.delta.bind(this);
    this.listenWheel = this.listenWheel.bind(this);
    this.scrollDown = this.scrollDown.bind(this);
    this.scrollUp = this.scrollUp.bind(this);
    this.scrollTop = this.scrollTop.bind(this);
    this.videos = this.$component.querySelectorAll(this.SELECTORS.video);
  }

  listenHeight() {
    this.setHeight();
    window.addEventListener('resize', () => this.setHeight());
  }
  setHeight() {
    this.page.style.scrollBehavior = 'smooth';
    document.body.style.overflowY = 'hidden';
    document.body.style.transition = 'transform .2s ease-in-out';
    let vh = window.innerHeight * 0.01;
    this.height = 100 * vh - this.headerHeight;
    document.documentElement.style.setProperty(
      '--journal-hp-height',
      `${this.height}px`
    );
  }

  listenCtas() {
    this.scrollCtas.forEach(cta => {
      cta.addEventListener('click', () => {
        this.handleScrollDown();
      });
    });
    this.topCta.addEventListener('click', () => {
      this.handleScrollTop();
    });
  }

  listenTouch() {
    let y = 0;
    window.addEventListener('touchstart', e => {
      y = e.changedTouches[0].pageY;
    });
    window.addEventListener('touchend', e => {
      if (e.target != this.topCta) {
        let newY = e.changedTouches[0].pageY;
        if (newY > y) {
          this.handleScrollUp();
        } else {
          this.handleScrollDown();
        }
      }
    });
  }

  listenWheel() {
    window.addEventListener('wheel', this.delta);
  }

  delta(e) {
    if (e.deltaY > 0) {
      this.handleScrollDown();
    } else {
      this.handleScrollUp();
    }
    window.removeEventListener('wheel', this.delta);
    setTimeout(this.listenWheel, 1500);
  }

  handleScrollDown() {
    this.currentSlide = this.slides[this.currentIndex];
    if (this.currentSlide) {
      if (this.currentIndex !== this.slides.length - 1) {
        this.currentSlide.classList.add('transition-out-down');
      }
    }
    let nextSlide = this.slides[this.currentIndex + 1];
    if (nextSlide) {
      nextSlide.classList.remove('transition-up');
      nextSlide.classList.remove('transition-in');
      nextSlide.classList.remove('transition-out-down');
      nextSlide.classList.remove('transition-out-up');
    }
    this.scrollDown();
  }

  handleScrollUp() {
    this.currentSlide = this.slides[this.currentIndex];
    if (this.currentSlide) {
      this.currentSlide.classList.add('transition-out-up');
    }
    let nextSlide = this.slides[this.currentIndex - 1];
    if (nextSlide) {
      if (this.currentIndex !== this.slides.length) {
        nextSlide.classList.remove('transition-up');
        nextSlide.classList.remove('transition-in');
        nextSlide.classList.remove('transition-out-down');
        nextSlide.classList.remove('transition-out-up');
      }
    }
    this.scrollUp();
  }

  scrollDown() {
    if (this.journalHero.getBoundingClientRect().top < 0) {
      this.page.scrollBy(0, this.height);
    } else {
      this.page.scrollBy(0, this.heroHeight);
      let benefitBar = document.querySelector('[data-benefit-bar]');
      let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
      document.body.style.transform = `translateY(-${barHeight}px)`;
    }
    if (this.currentIndex < this.slides.length) {
      this.currentIndex += 1;
    }
    this.currentSlide = this.slides[this.currentIndex];
    if (this.currentSlide) {
      this.currentSlide.classList.add('transition-in');
    }
  }

  scrollUp() {
    if (
      this.footerHeight < this.height &&
      this.footer.getBoundingClientRect().top < this.height
    ) {
      this.page.scrollBy(0, -this.footerHeight);
    } else if (
      this.footerHeight > this.height &&
      this.footer.getBoundingClientRect().top < this.headerHeight
    ) {
      this.page.scrollBy(0, -this.footerHeight);
    } else {
      this.page.scrollBy(0, -this.height);
      if (this.journalHero.getBoundingClientRect().bottom > 0) {
        document.body.style.transform = 'translateY(0)';
      }
    }
    if (this.currentIndex > -1) {
      this.currentIndex -= 1;
    }
    this.currentSlide = this.slides[this.currentIndex];
    if (this.currentSlide) {
      this.currentSlide.classList.add('transition-up');
      setTimeout(() => {
        this.currentSlide.classList.add('transition-in');
      }, 10);
    }
  }

  handleScrollTop() {
    this.currentSlide = this.slides[this.currentIndex];
    if (this.currentSlide) {
      this.currentSlide.classList.add('transition-out-up');
    }
    this.currentIndex = 0;
    this.currentSlide = this.slides[this.currentIndex];
    this.currentSlide.classList.remove('transition-up');
    this.currentSlide.classList.remove('transition-in');
    this.currentSlide.classList.remove('transition-out-down');
    this.currentSlide.classList.remove('transition-out-up');
    this.scrollTop();
  }

  scrollTop() {
    this.page.scrollTo(0, this.heroHeight);
    this.currentSlide.classList.add('transition-up');
    setTimeout(() => {
      this.currentSlide.classList.add('transition-in');
    }, 10);
  }

  listenVideos() {
    this.videos.forEach(video => {
      let instance = new VideoBrightcoveComponent(video);
      instance.init();
      this.initObserver(video);
    });
  }

  initObserver(el) {
    let options = {
      rootMargin: '0px',
      threshold: [0.5],
    };
    let callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let video = el.querySelector('video');
          if (video) {
            video.play();
            observer.unobserve(el);
          }
        }
      });
    };
    let observer = new IntersectionObserver(callback, options);
    observer.observe(el);
  }

  render() {
    this.log('Rendering...');
    // prevent reloading on previous position
    window.scrollTo(0, 0);
    this.listenHeight();
    this.listenCtas();
    this.listenWheel();
    this.listenTouch();
    this.listenVideos();
  }
}
